interface IRelatedPublisherSource {
  type_publisher?: string;
  publisher_news?: unknown;
  publisher_events?: unknown;
}

/*
  Элементы публикатора, вложенного в хронику. «Афиша: Мероприятия»
  (retail_magazine) собирается из мероприятий, остальные — из новостей.
*/
export const getRelatedPublisherItems = (
  publisher: IRelatedPublisherSource,
): unknown =>
  (publisher.type_publisher === 'retail_magazine'
    ? publisher.publisher_events
    : publisher.publisher_news) || [];
